import { ApolloClient } from '@apollo/client/core'

import { apolloClientOptions } from './apolloClientOptions'
import genericErrorLink from './genericErrorLink'
import { jobsHttpLink } from './jobsHttpLink'
import localeLink from './localeLink'

export const jobsApolloClient = new ApolloClient({
  ...apolloClientOptions,
  link: localeLink.concat(genericErrorLink).concat(jobsHttpLink),
  devtools: {
    enabled: process.env.NODE_ENV === 'development',
  },
})
